import FlexBox from "lib/components/common/flex-box";
import AuthenticationLayout from "lib/components/layouts/authentication";

const MaintenancePage = () => {
  return (
    <AuthenticationLayout>
      <FlexBox
        className="h-100 px-3 text-center"
        justifyContent="center"
        alignItems="center"
      >
        <FlexBox
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{ maxWidth: 620 }}
        >
          <h1 className="fw-bold mb-4 display-4">
            We’ll Be Back Soon
          </h1>

          <p className="text-muted mb-4 fs-4">
            Our website is currently undergoing scheduled maintenance to enhance
            performance and improve your overall experience. We’ll be back
            online shortly.
          </p>

          <div className="mb-5">
            <p className="fw-semibold mb-3 fs-4">
              Need assistance?
            </p>

            <p className="mb-2 fs-5">
              📞 <strong>Phone:</strong> +44 208 125 4084
            </p>
            <p className="mb-2 fs-5">
              ✉️ <strong>Email:</strong> info@heal-wellness.co.uk
            </p>
            <p className="mb-0 fs-5">
              📱 <strong>WhatsApp:</strong> 07990 482014
            </p>
          </div>

          <p className="text-muted fs-5 mb-0">
            Thank you for your patience and understanding.
          </p>
        </FlexBox>
      </FlexBox>
    </AuthenticationLayout>
  );
};

export default MaintenancePage;
